import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const changeCheckoutEntrySchema = z.object({
  checkout_entry_type: optionSchema,
  responsible: optionSchema,
})

export type ChangeCheckoutEntryValidationSchema = z.infer<typeof changeCheckoutEntrySchema>
